import { ObservableFromFetch } from "../ObservableFromFetch"

export  interface CheckUserExistsParameters {
 UserName: string 
 ImplementationID: number
 CompanyID: number
 LocationID: number
 RoleID: number
 Link: string
}

export  interface CheckUserExistsResult {
 UserExists: number
 ContactExists: number
 Error: string
}

export default function CheckExistingUser(params: {UserName: string, Link?: string}) {
  const requestBody = JSON.stringify(params)
  return ObservableFromFetch<string>("FFOrderUserInvitation/CheckExistingUser", requestBody)
}

export function CheckUserExists(params: CheckUserExistsParameters) {
  const requestBody = JSON.stringify(params)
  return ObservableFromFetch<CheckUserExistsResult>("FFOrderUserInvitation/CheckUserExists", requestBody)
}